import { AssignmentListView, AttachDialogView, ProductLegalTextsView, ResolvePreviewView } from '@today/ui-domain'
import { useProductLegalTexts } from '@/hooks/content/useProductLegalTexts'

/** The product editor's "Legal texts" tab (TO-420 content-admin-ui REQ-010/REQ-011). */
export function ProductLegalTextsTab({ productId }: { productId: string }) {
	const legal = useProductLegalTexts(productId)
	return (
		<>
			<ProductLegalTextsView
				{...legal.panel}
				own={<AssignmentListView {...legal.own} />}
				preview={<ResolvePreviewView {...legal.preview} />}
			/>
			<AttachDialogView {...legal.attach} />
		</>
	)
}
